import { addFilter } from '@wordpress/hooks';
import { useSelect, select, dispatch, withSelect } from '@wordpress/data';
import { _n, __ } from '@wordpress/i18n';
import { PanelRow, ToggleControl, TextareaControl, FormTokenField } from '@wordpress/components';
import Select from 'react-select'

import SettingsFieldEditor from './tab-components/SettingsFieldEditor'
import MiscFieldEditor from './tab-components/MiscFieldEditor'

addFilter('wp_travel_settings_tab_field_editor_fields', 'wp_travel', (content, ...params) => {
    // content.splice(0, 1)
    return [...content, <SettingsFieldEditor />]
}
);
addFilter('wp_travel_settings_tab_misc_options_fields', 'wp_travel', (content, ...params) => {
    return [...content, <MiscFieldEditor />]
}
);
addFilter('wp_travel_settings_tab_misc_recaptcha_v2', 'wp_travel', (content, ...params) => {
    return [...content, <MiscFieldEditor />]
}
);